import {getBranchLocator} from '../../../../rest/locators'
import type {Branch} from '../../../../services/rest'
import type {BuildId, BuildTypeId, ProjectId} from '../../../../types'
import {stringifyId} from '../../../../types'
import {VISIBLE_COUNT} from '../Changes.consts'
import {useChangesFilter, useCurrentPage} from '../Changes.hooks'

export function useChangeLogLocator({
  buildId,
  buildTypeId,
  projectId,
  branch,
  pending,
  visibleCount = VISIBLE_COUNT,
  showBuilds,
}: {
  buildId?: BuildId | null | undefined
  buildTypeId?: BuildTypeId | null | undefined
  projectId?: ProjectId | null | undefined
  branch?: Branch | null | undefined
  pending?: boolean
  visibleCount?: number
  showBuilds?: boolean
}): string | null {
  const currentPage = useCurrentPage()
  const {filterOptions} = useChangesFilter(buildTypeId)

  const {
    username,
    comment,
    path,
    revision,
    fromBuildNumber,
    toBuildNumber,
    showDependenciesChanges,
  } = filterOptions

  return [
    buildId != null ? `build:${stringifyId(buildId)}` : null,
    buildId == null && buildTypeId != null ? `buildType:${buildTypeId}` : null,
    buildId == null && buildTypeId == null && projectId != null ? `project:${projectId}` : null,
    buildId == null ? getBranchLocator(branch, true) : null,
    pending != null ? `pending:${pending}` : null,
    showDependenciesChanges != null ? `changesFromDependencies:${showDependenciesChanges}` : null,
    currentPage != null ? `page:${currentPage}` : 'page:1',
    username != null ? `vcsUsername:${username}` : null,
    showBuilds != null ? `includeBuilds:${showBuilds}` : null,
    fromBuildNumber !== '' ? `fromBuildNumber:${fromBuildNumber}` : null,
    toBuildNumber !== '' ? `toBuildNumber:${toBuildNumber}` : null,
    comment !== '' ? `comment:(value:${comment},matchType:contains,ignoreCase:true)` : null,
    path !== '' ? `path:(value:${path},matchType:contains,ignoreCase:true)` : null,
    revision !== '' ? `revision:(value:${revision},matchType:contains,ignoreCase:true)` : null,
    `pageSize:${visibleCount}`,
  ]
    .filter(Boolean)
    .join(',')
}
